import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=a389c0a6&scoped=true"
import script from "./DetailsTable.vue?vue&type=script&lang=js"
export * from "./DetailsTable.vue?vue&type=script&lang=js"
import style0 from "./DetailsTable.vue?vue&type=style&index=0&id=a389c0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a389c0a6",
  null
  
)

export default component.exports